import styled from 'styled-components';

import UModal from 'components/Modal';

export const TextareaWrapper = styled.div`
  position: relative;
`;

export const Modal = styled(UModal)`
  width: 360px;
`;
